import { Component, OnInit } from '@angular/core';
import { NavigationHistoryService, RecentNavItem } from 'src/app/ui/navigation-history.service';

export interface ToolLink {
  path: string;
  label: string;
}

export interface ToolGroup {
  id: string;
  title: string;
  tools: ToolLink[];
}

@Component({
  standalone: false,
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css'],
})
export class LandingComponent implements OnInit {
  readonly docsUrl = 'https://docs.epago.pe/';
  recent: RecentNavItem[] = [];
  toolQuery = '';

  readonly quickActions: ToolLink[] = [
    { path: '/checkout2', label: 'Checkout' },
    { path: '/paylink', label: 'Crear PayLink' },
    { path: '/ordenes', label: 'Buscar orden' },
    { path: '/agora-simulator-control', label: 'Simulador' },
  ];

  readonly toolGroups: ToolGroup[] = [
    {
      id: 'payments',
      title: 'Pagos',
      tools: [
        { path: '/checkout2', label: 'Checkout' },
        { path: '/checkout-react-qr', label: 'Checkout React QR' },
        { path: '/paylink', label: 'PayLink' },
        { path: '/sip-pay', label: 'Pago con Sip' },
      ],
    },
    {
      id: 'cards',
      title: 'Tarjetas',
      tools: [
        { path: '/card-register', label: 'Registro de tarjeta' },
        { path: '/saved-card-pay', label: 'Pago tokenizado' },
      ],
    },
    {
      id: 'tools',
      title: 'Herramientas',
      tools: [
        { path: '/processor-benefit', label: 'Procesador Benefit' },
        { path: '/agora-simulator-control', label: 'Control del simulador' },
        { path: '/izipay-generator', label: 'Generador por lote F5' },
        { path: '/ordenes', label: 'Órdenes' },
        { path: '/estilos-inyectables', label: 'Estilos inyectables' },
      ],
    },
  ];

  constructor(private navHistory: NavigationHistoryService) {}

  ngOnInit(): void {
    this.recent = this.navHistory.getRecent();
  }

  matchesQuery(text: string): boolean {
    const q = this.toolQuery.trim().toLowerCase();
    if (!q) {
      return true;
    }
    return text.toLowerCase().includes(q);
  }

  filteredGroup(group: ToolGroup): ToolGroup | null {
    const tools = group.tools.filter(
      (t) => this.matchesQuery(t.label) || this.matchesQuery(t.path),
    );
    if (!tools.length) {
      return null;
    }
    return { ...group, tools };
  }

  get visibleGroups(): ToolGroup[] {
    return this.toolGroups
      .map((g) => this.filteredGroup(g))
      .filter((g): g is ToolGroup => g !== null);
  }

  get filteredQuickActions(): ToolLink[] {
    return this.quickActions.filter(
      (a) => this.matchesQuery(a.label) || this.matchesQuery(a.path),
    );
  }

  get filteredRecent(): RecentNavItem[] {
    return this.recent.filter(
      (r) => this.matchesQuery(r.label) || this.matchesQuery(r.path),
    );
  }
}
